define('taoQtiItem/qtiXmlRenderer/renderers/choices/SimpleChoice',['tpl!taoQtiItem/qtiXmlRenderer/tpl/element'], function(tpl){
    return {
        qtiClass : 'simpleChoice',
        template : tpl
    };
});
